import { defaultHttpClient } from '../../httpClient';
import type { GetMarketRankingFilterOptionsResponse } from './types';

export const getMarketRankingFilterOptions = (marketTypeSno: number) => {
  return defaultHttpClient
    .request<GetMarketRankingFilterOptionsResponse>({
      method: 'GET',
      url: `/api/v2/markets/rankings/${marketTypeSno}/filter_options/`,
    })
    .then(result => result.data);
};
